export loadingHandler from './loadingHandler';



/** WEBPACK FOOTER **
 ** ./client/store/middlewares/promiseHandlers/index.js
 **/